import React, { useState } from 'react';
import { Phone, Mail, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
export function FinalCTA() {
  const [activeTab, setActiveTab] = useState(0);
  const {
    t
  } = useLanguage();
  const ctas = [{
    label: t('cta.t1'),
    text: t('cta.c1')
  }, {
    label: t('cta.t2'),
    text: t('cta.c2')
  }, {
    label: t('cta.t3'),
    text: t('cta.c3')
  }];
  return <section className="py-24 lg:py-32 bg-brand-black relative overflow-hidden" data-id="element-64">
      {/* Background glow */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none" data-id="element-65">
        <div className="w-[800px] h-[800px] bg-brand-gold/5 rounded-full blur-[100px]" data-id="element-66"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-67">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-5xl font-serif font-bold text-white mb-6" data-id="element-68">
          {t('cta.title')}
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-xl text-brand-gold font-medium mb-12" data-id="element-69">
          {t('cta.desc')}
        </motion.p>

        {/* Interactive CTA Message Selector */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="bg-brand-dark border border-white/10 rounded-2xl p-8 mb-12" data-id="element-70">
          <div className="flex flex-wrap justify-center gap-2 mb-8" data-id="element-71">
            {ctas.map((cta, index) => <button key={index} onClick={() => setActiveTab(index)} className={`px-4 py-2 rounded-full text-sm font-bold transition-colors ${activeTab === index ? 'bg-brand-gold text-brand-black' : 'bg-white/5 text-white/50 hover:text-white hover:bg-white/10'}`} data-id="element-72">
                {cta.label}
              </button>)}
          </div>

          <div className="min-h-[100px] flex items-center justify-center" data-id="element-73">
            <p className="text-2xl md:text-3xl font-serif text-white leading-relaxed text-balance" data-id="element-74">
              "{ctas[activeTab].text}"
            </p>
          </div>
        </motion.div>

        {/* Action Buttons */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="flex flex-col sm:flex-row justify-center gap-6" data-id="element-75">
          <a href="tel:8137534656" className="group flex items-center justify-center gap-3 bg-brand-gold hover:bg-brand-goldLight text-brand-black px-8 py-5 rounded-xl font-bold text-xl transition-all transform hover:scale-105 shadow-[0_0_30px_rgba(212,164,55,0.2)]" data-id="element-76">
            <Phone className="w-6 h-6" data-id="element-77" />
            <span data-id="element-78">813-753-4656</span>
            <ArrowRight className="w-5 h-5 opacity-0 -ml-5 group-hover:opacity-100 group-hover:ml-0 transition-all" data-id="element-79" />
          </a>

          <a href="mailto:jomeliteconstruction@gmail.com" className="flex items-center justify-center gap-3 bg-transparent border-2 border-white/20 hover:border-brand-gold text-white px-8 py-5 rounded-xl font-bold text-xl transition-all hover:bg-white/5" data-id="element-80">
            <Mail className="w-6 h-6" data-id="element-81" />
            <span className="hidden sm:inline" data-id="element-82">
              jomeliteconstruction@gmail.com
            </span>
            <span className="sm:hidden" data-id="element-83">{t('cta.btn1')}</span>
          </a>
        </motion.div>
      </div>
    </section>;
}